export enum MembershipType {
  Premium = 'premium',
  Free = 'free',
}
